import { useContext } from 'react'
import { ModalbarContext } from './ModalbarProvider'
/**
 * @function useModalbar
 * @return {Object} {callModalbar, closeModalbar}
 */
const useModalbar = () => useContext(ModalbarContext)
export default useModalbar
